import React, { useState } from 'react'
import Container from 'react-bootstrap/Container'
import Logo from '../images/logo2.png'
import emailjs from '@emailjs/browser';
import Contact from '../pages/contact'

//service_wjjryxt
function Contactus() {

    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        message: ''
    });

    const [EmailSent, setEmailSent] = useState(false);
    const [isMobileValid, setIsMobilevalid] = useState(false);
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [touched, setTouched] = useState({ name: false, mobile: false, email: false, message: false });

    //const [mobileValidation, setMobileValidation] = useState('');
    //const [emailValidation, setEmailValidation] = useState('');


    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "mobile") {
            if (value === '' || /^\d{10}$/.test(value) === false) {
                //setMobileValidation('Please enter a valid 10-digit mobile number');
            }
            setIsMobilevalid(/^\d{10}$/.test(value));
        }

        if (name === 'email') {
            if (value === '' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) === false) {
                //setEmailValidation('Please enter a valid email address');
            }
            setIsEmailValid(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value));
        }
        setFormData({ ...formData, [name]: value });

    };

    const isFormValid = isMobileValid
        && isEmailValid
        && formData.name.trim() !== ''
        && formData.message.trim() !== '';


    function onsubmit(e) {

        e.preventDefault();
        if (!isFormValid) {
            //setMobileValidation(isMobileValid ? '' : 'Please enter a valid 10-digit mobile number');
            //setEmailValidation(isEmailValid ? '' : 'Please enter a valid email address');
            return
        }
        else {
            //setMobileValidation('');
            //setEmailValidation('');
            emailjs.send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                formData,
                { publicKey: process.env.REACT_APP_EMAILJS_SECRET_KEY }
            )
                .then(
                    (result) => {
                        console.log(result.text);
                        setEmailSent(true);

                    },
                    (error) => {
                        console.log(error.text);
                        setEmailSent(false);
                    }
                );
        }
    }


    return (
        <>
            <div className="con-image">
                <img src={Logo} alt='Azion' style={{ "width": "50%", "minWidth": "250px" }} /><br />
            </div>
            <Container fluid className='p-0'>

                <div className='con-intro'>
                    <Contact />
                </div>

                <div class="row">
                    <div className='col'>
                        {EmailSent ? <div className='m-5 h-50 column' ><div class="alert alert-success pt-10 p-5" role="alert">
                            Email Sent Successfully
                        </div><br /><br /><br /><br /><br /><br /><br /><br /><br /></div> :

                            <form className='px-5 py-2 my-4' >
                                <div>
                                    <label htmlFor="name" class="form-label">Name:</label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        className="form-control"
                                        value={formData.name}
                                        onChange={handleChange}
                                        onBlur={() => setTouched({ ...touched,name: true })}
                                        required
                                    />
                                    { touched.name &&  formData.name.trim() === '' ? <label class="form-label text-danger">Name is a required</label> : null}
                                    
                                </div>
                                <div>
                                    <label htmlFor="mobile" class="form-label mt-3">Mobile:</label>
                                    <input
                                        type="tel"
                                        id="mobile"
                                        name="mobile"
                                        className="form-control"
                                        value={formData.mobile}
                                        onChange={handleChange}
                                        onBlur={() => setTouched({ ...touched,mobile: true })}
                                        pattern="[0-9]{10}"
                                        placeholder='10 digit mobile number'
                                        required
                                    />
                                { touched.mobile && isMobileValid === false ? <label class="form-label text-danger">A 10 digit mobile number is required</label> : null}
                                    <br></br>
                                </div>
                                <div>
                                    <label htmlFor="email" class="form-label">Email:</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="name@example.com"
                                        className="form-control"
                                        value={formData.email}
                                        pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
                                        onChange={handleChange}
                                        onBlur={() => setTouched({ ...touched,email: true })}
                                        required
                                    />
                                    { touched.email && isEmailValid === false ? <label class="form-label text-danger">Please enter a valid email address</label> : null}
                                    <br></br>
                                </div>
                                <div>
                                    <label htmlFor="message" class="form-label mt-3">Message:</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        className="form-control"
                                        value={formData.message}
                                        onChange={handleChange}
                                        onBlur={() => setTouched({ ...touched,message: true })}
                                        rows="4"
                                        required
                                    />
                                       { touched.message && formData.message.trim() === '' ? <label class="form-label text-danger">Please enter a message or question</label> : null}
                                    <br></br>
                                </div>
                                <div class="d-grid m-5">
                                    <button type="button" onClick={onsubmit} className='btn btn-primary btn-lg' disabled={!isFormValid} >Submit</button>
                                </div>
                            </form>

                        }
                    </div>

                </div>
            </Container >
        </>
    );
}

export default Contactus;

